module.exports = __webpack_public_path__ + "static/img/04.13faee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/04.jpg
// module id = M8SR
// module chunks = 0